import { Component, inject } from '@angular/core';
import { MenuController, Platform } from '@ionic/angular';
import { LogService, LocalStorageService, environment } from '@ups/xplat/core';
import { AppBaseComponent } from '@ups/xplat/web/core';
import { getAppVersionInfo } from '@ups/xplat/web/utils';
import { EnterpriseStorageKeys } from './utils';

@Component({
  selector: 'ups-root',
  templateUrl: 'app.component.html',
  standalone: false,
})
export class AppComponent extends AppBaseComponent {
  platform = inject(Platform);
  log = inject(LogService);
  menu = inject(MenuController);
  storage = inject(LocalStorageService);
  version = getAppVersionInfo().versionName;
  environment = environment;

  constructor() {
    super();
    this.initializeApp();
  }

  initializeApp() {
    this.platform.ready().then(() => {
      this.log.debug('platform ready');
    });
  }

  closeMenu() {
    this.menu.enable(true, 'custom');
    this.menu.close('custom');
  }

  logout() {
    this.auth.logout({
      returnTo: `${window.location.protocol}//${window.location.host}`,
    });
    this.storage.removeItem(EnterpriseStorageKeys.helpComplete);
    this.storage.removeItem('profile');
    this.storage.removeItem('id_token');
  }

  showApps() {
    this.router.navigate(['/home/apps']);
  }

  showHelp() {
    this.storage.removeItem(EnterpriseStorageKeys.helpComplete);
    this.router.navigate(['/']);
  }
}
